import React from 'react';

import ProgramGroupCard from '../cards/program-result-card';
import ProgramCard from '../cards/program-card';
import ArticleCard from '../cards/article-card';
import EventCard from '../cards/event-card';
import FinancialCard from '../cards/financial-card';
import WorkStudyInternshipCard from '../cards/work-study-internship-card';
import ExperientialLearningCard from '../cards/experiential-learning-card';
import ResourceListingCard from '../cards/resource-listing-card';
import OtherResultCard from '../cards/other-result-card';
import StaffCard from '../cards/staff-card';
import CommunityResourceCard from '../cards/community-resource-card';

const cardTypeMap = {
  article: ArticleCard,
  event: EventCard,
  experientialLearning: ExperientialLearningCard,
  financial: FinancialCard,
  program: ProgramCard,
  programGroup: ProgramGroupCard,
  staff: StaffCard,
  workStudyInternship: WorkStudyInternshipCard,
  resource: ResourceListingCard,
  community: CommunityResourceCard,
  other: OtherResultCard
};

export const getCardComponent = (
  type,
  attributes,
  id,
  emailAriaLabel,
  phoneAriaLabel,
  externalLinkText,
  resourceTypesLabel,
  eligibilityLabel,
  ageGroupsLabel,
  partnersLabel
) => {
  const Card = cardTypeMap[type];

  return (
    Card && (
      <Card
        key={id}
        id={id}
        externalLinkText={externalLinkText}
        resourceTypesLabel={resourceTypesLabel}
        eligibilityLabel={eligibilityLabel}
        ageGroupsLabel={ageGroupsLabel}
        partnersLabel={partnersLabel}
        {...attributes}
        {...(type === 'staff' && { emailAriaLabel, phoneAriaLabel })}
      />
    )
  );
};
